module.exports = __webpack_public_path__ + "static/media/icn-info.2af7635e.svg";